import { supabase } from "../lib/supabase";

const DEFAULT_MAX_DETAIL_URLS = 20;

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Not signed in. Please log in.");
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

/**
 * For custom URL imports, `singleEventDetailPagePreference` is stored on activity_sources.
 *
 * @param {{
 *   dryRun?: boolean,
 *   maxDetailUrls?: number,
 *   archiveGraceHours?: number,
 *   crossSourceDedupe?: boolean,
 *   allowLlmFallback?: boolean,
 *   singleEventDetailPage?: boolean,
 *   singleEventDetailPagePreference?: boolean,
 *   sourceUrl?: string,
 *   customSourceUrl?: boolean,
 * }} payload
 */
export async function runActivitiesImport(payload = {}) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/source-import/activities`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      dryRun: payload.dryRun !== false,
      maxDetailUrls:
        payload.maxDetailUrls != null
          ? payload.maxDetailUrls
          : DEFAULT_MAX_DETAIL_URLS,
      archiveGraceHours: payload.archiveGraceHours,
      crossSourceDedupe: payload.crossSourceDedupe !== false,
      allowLlmFallback: payload.allowLlmFallback !== false,
      singleEventDetailPage: payload.singleEventDetailPage === true,
      ...(typeof payload.singleEventDetailPagePreference === "boolean"
        ? { singleEventDetailPagePreference: payload.singleEventDetailPagePreference }
        : {}),
      sourceUrl: payload.sourceUrl || "",
      customSourceUrl: payload.customSourceUrl === true,
    }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Import failed (${res.status}).`);
  }
  return data;
}


